import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/ic-drop-down.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "color-selector",
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showMenu = !_ctx.showMenu), ["stop"]))
  }, [
    _createElementVNode("span", {
      class: "color-selector__current",
      style: _normalizeStyle(`background: ${_ctx.modelValue.color}`)
    }, null, 4),
    _hoisted_1,
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "color-selector__menu",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectStatuses, (status) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (status.value !== _ctx.exclude)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["color-selector__menu-item", { 'color-selector__menu-item--selected': _ctx.modelValue.name === status.name }]),
                    onClick: ($event: any) => (_ctx.itemClick(status))
                  }, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(`background: ${status.color}`)
                    }, null, 4),
                    _createElementVNode("span", null, _toDisplayString(status.name), 1)
                  ], 10, _hoisted_2))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ]))
}